export const SITE = {
  name: 'Janmesh Joshi',
  title: 'AI / ML Engineer',
  tagline:
    'I ship production LLM systems: fine-tuning, RAG, and agentic platforms.',
  email: 'janmesh5900@gmail.com',
  phone: '+353 89 229 9380',
  location: 'Dublin, Ireland',
  timezone: 'Europe/Dublin',
  resumePath: '/janmesh-joshi-resume.pdf',
  url: process.env.REACT_APP_SITE_URL || 'https://janmeshjoshi.dev',
};

export const HERO = {
  eyebrow: 'AI / ML Engineer · Dublin',
  // Words wrapped in <em> render in the italic serif accent style.
  headline: 'I build AI that keeps working <em>after the demo.</em>',
  intro:
    'Four years of fine-tuning, retrieval and inference that has to answer on time. Days at ORCAWISE in Dublin, fine-tuning Llama and running agentic RAG over 10,000+ enterprise documents. Nights on MyNextRoom, a rental app I built because finding a room in Dublin is a competitive sport.',
  status: [
    { k: 'role', v: 'AI Engineer @ ORCAWISE' },
    { k: 'focus', v: 'LoRA · RLHF · agentic RAG' },
    { k: 'stack', v: 'Python · FastAPI · AWS · K8s' },
    { k: 'open_to', v: 'AI Eng · Applied ML · founding' },
    { k: 'coffee', v: 'yes, please' },
  ],
};

export const SOCIAL = [
  { label: 'LinkedIn', href: 'https://linkedin.com/in/janmeshjoshi/' },
  { label: 'GitHub', href: 'https://github.com/janmeshj' },
  { label: 'Email', href: 'mailto:janmesh5900@gmail.com' },
  { label: 'YouTube', href: 'https://www.youtube.com/@ActuallyIndian_AI/' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@actually.indian.ai' },
];

export const NAV_LINKS = [
  { label: 'Experience', href: '#experience', id: 'experience' },
  { label: 'Work', href: '#projects', id: 'projects' },
  { label: 'About', href: '#about', id: 'about' },
  { label: 'Skills', href: '#skills', id: 'skills' },
  { label: 'Contact', href: '#contact', id: 'contact' },
];

export const HERO_STATS = [
  { v: 4, suffix: '+', l: 'Years production ML', sub: 'Mumbai → Dublin' },
  { v: 60, suffix: '%', l: 'Faster document processing', sub: 'Fine-tuned LLMs + retrieval, ORCAWISE' },
  { v: 35, suffix: '%', l: 'Retrieval lift vs BM25', sub: '500k+ legal cases, Panghat' },
  { v: 10, suffix: '×', l: 'Faster vector search', sub: 'HNSW tuning on Milvus' },
];

export const MARQUEE_ITEMS = [
  'Llama fine-tuning',
  'LoRA / RLHF',
  'Agentic RAG',
  'AWS SageMaker',
  'FastAPI',
  'Kubernetes',
  'Milvus / HNSW',
  'LangChain',
  'PyTorch',
  'Weights & Biases',
  'React Native',
  'PostgreSQL',
];
